module.exports = __webpack_public_path__ + "assets/img/29_201_big.f13bba80.jpg";